import { useTheme } from '../platform/theme/useTheme'
import type { ThemeMode } from '../platform/theme/themeContext'
import { useT } from '../platform/i18n/useT'
import { haptics } from '../platform/telegram'
import './TopBar.css'

/**
 * Компактная панель управления сверху: тема и язык.
 *
 * Монтируется один раз в App, поэтому доступна на всех экранах
 * и не дублируется в каждом. Раньше это были строки списка -
 * они съедали пол-экрана ради двух редких действий.
 */

const ORDER: readonly ThemeMode[] = ['auto', 'light', 'dark']

export function TopBar() {
  const { mode, setMode } = useTheme()
  const { lang, setLang, t } = useT()

  const cycleTheme = () => {
    haptics.select()
    const i = ORDER.indexOf(mode)
    setMode(ORDER[(i + 1) % ORDER.length] ?? 'auto')
  }

  const toggleLang = () => {
    haptics.select()
    setLang(lang === 'ru' ? 'en' : 'ru')
  }

  return (
    <div className="topbar">
      <button
        type="button"
        className="topbar__btn"
        onClick={cycleTheme}
        aria-label={t(`settings.theme.${mode}`)}
        title={t(`settings.theme.${mode}`)}
      >
        <ThemeIcon mode={mode} />
      </button>

      <button
        type="button"
        className="topbar__btn topbar__btn--text"
        onClick={toggleLang}
        aria-label={t('settings.language')}
      >
        {lang.toUpperCase()}
      </button>
    </div>
  )
}

function ThemeIcon({ mode }: { mode: ThemeMode }) {
  if (mode === 'light') {
    return (
      <svg viewBox="0 0 20 20" width="17" height="17" fill="none" aria-hidden="true">
        <circle cx="10" cy="10" r="3.6" stroke="currentColor" strokeWidth="1.6" />
        <g stroke="currentColor" strokeWidth="1.6" strokeLinecap="round">
          <path d="M10 2v2M10 16v2M2 10h2M16 10h2M4.3 4.3l1.4 1.4M14.3 14.3l1.4 1.4M15.7 4.3l-1.4 1.4M5.7 14.3l-1.4 1.4" />
        </g>
      </svg>
    )
  }
  if (mode === 'dark') {
    return (
      <svg viewBox="0 0 20 20" width="17" height="17" fill="none" aria-hidden="true">
        <path
          d="M16 11.4A6.6 6.6 0 0 1 8.6 4a6.6 6.6 0 1 0 7.4 7.4Z"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
  // авто - половина закрашена
  return (
    <svg viewBox="0 0 20 20" width="17" height="17" aria-hidden="true">
      <circle cx="10" cy="10" r="6.4" fill="none" stroke="currentColor" strokeWidth="1.6" />
      <path d="M10 3.6a6.4 6.4 0 0 1 0 12.8Z" fill="currentColor" />
    </svg>
  )
}
